import { Maybe } from '@vimeo/core/types/generic';

import { environmentConfig } from '../../configs/EnvironmentConfig';
import { EComposerSessionType } from '../../types/composer_session';

/**
 * Transform URI part to absolute link where needed.
 */
export function transformUriToAbsolute(uri?: string): string {
  /**
   * Ignore absolute links.
   */
  if (uri && uri.startsWith('http')) {
    return uri;
  }

  return uri ? `${environmentConfig.URL_BASE}${uri}` : '';
}

/**
 * Based on raw input get matching session type.
 */
export function transformUriParamToSessionType<T extends string>(
  rawSessionType: Maybe<T>,
): EComposerSessionType {
  /**
   * Shortcut for event word.
   */
  if (rawSessionType === 'event') {
    return EComposerSessionType.LIVE_EVENT;
  } else if (Object.values(EComposerSessionType).includes(rawSessionType as EComposerSessionType)) {
    return rawSessionType as EComposerSessionType;
  } else {
    return EComposerSessionType.UNKNOWN;
  }
}

/**
 * Based on session type, generate shortcut for URI usage.
 */
export function transformSessionTypeToUri(sessionType: EComposerSessionType): string {
  if (sessionType === EComposerSessionType.LIVE_EVENT) {
    return 'event';
  }

  return sessionType;
}
